export enum ProcessFlowTypeEnum {
  Monitoring = 0,
  SalesFunnel = 1,
}
